import { api } from '../../shared/lib/api';
import type {
  AbrirComandaInput,
  AtualizarComandaInput,
  Comanda,
  ComandaResumo,
  ComandaStatus,
  ConfigComandas,
  ComandaItensResponse,
} from './types';

export const comandasApi = {
  list: (params: { status?: ComandaStatus; q?: string } = {}) => {
    const qs: Record<string, string> = {};
    if (params.status) qs.status = params.status;
    if (params.q) qs.q = params.q;
    return api.get<Comanda[]>('comandas', qs);
  },
  getById: (id: string) => api.get<Comanda>(`comandas/${id}`),
  resumo: (id: string) => api.get<ComandaResumo>(`comandas/${id}/resumo`),
  abrir: (body: AbrirComandaInput) => api.post<Comanda>('comandas', body),
  atualizar: (id: string, body: AtualizarComandaInput) =>
    api.patch<Comanda>(`comandas/${id}`, body),
  cancelar: (id: string) => api.delete<Comanda>(`comandas/${id}`),
  getConfig: () => api.get<ConfigComandas>('comandas/config'),
  setConfig: (body: ConfigComandas) => api.post<ConfigComandas>('comandas/config', body),
  getItens: (id: string) => api.get<ComandaItensResponse>(`comandas/${id}/itens`),
  adicionarItens: (id: string, body: { itens: any[] }) =>
    api.post<any>(`comandas/${id}/itens`, body),
};
